import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import { MUTATE } from '@/store/modules/mutation_types';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackPrefetch: true */ './views/LoginView.vue'),
    },
    {
      path: '/',
      name: 'home',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/Home.vue'),
      children: [
        {
          path: '/',
          name: 'universes',
          component: () => import('./views/UniversesView.vue'),
          props: true
        },
        {
          path: '/pesquisas',
          name: 'universes',
          component: () => import('./views/UniversesView.vue'),
          props: true
        }
      ]
    },
    {
      path: '/access',
      name: 'access',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/Home.vue'),
      children: [
        {
          path: '/access',
          name: 'access',
          component: () => import('./views/AccessView.vue'),
          props: true
        },
      ]
    },
    {
      path: '/error',
      alias: ['403', '500'],
      name: 'error',
      component: () => import(/* webpackPrefetch: true */ './views/ErrorPageWrapper.vue'),
      props: true
    },
    {
      path: '*',
      redirect: 'error',
      props: true
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.commit(`misc/${MUTATE}`, {
    property: 'hasInitialData',
    with: false
  });
  next();
});

router.afterEach(() => {
  store.commit(`misc/${MUTATE}`, {
    property: 'hasInitialData',
    with: true
  });
});

export default router;
